"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CryptoJS = require("crypto-js");
var base58_1 = require("../libs/base58");
var param_1 = require("./param");
exports.base64Decode = function (input) {
    return param_1._fromWords(CryptoJS.enc.Base64.parse(input));
};
exports.base64Encode = function (input) {
    return CryptoJS.enc.Base64.stringify(param_1._toWords(param_1._fromIn(input)));
};
exports.base58Decode = function (input) {
    return base58_1.default.decode(input);
};
exports.base58Encode = function (input) {
    return base58_1.default.encode(param_1._fromIn(input));
};
exports.base16Decode = function (input) {
    return param_1._fromWords(CryptoJS.enc.Hex.parse(input));
};
exports.base16Encode = function (input) {
    return CryptoJS.enc.Hex.stringify(param_1._toWords(param_1._fromIn(input)));
};
//# sourceMappingURL=base-xx.js.map